<template>
  <div class="float-right mr-5">
    <b-button
      :to="{ name: 'usuario-editar-mi-perfil'}"
      variant="primary"
    >
      Editar Mi Perfil
    </b-button>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  components: { BButton },
}
</script>
